import { registerSem } from '../registry';

// Chunked artifact handlers (started/completed only)

// Extract stable entity ID by removing the ":N" chunk suffix
function getStableEntityId(itemId: string): string {
  // item_id format is "uuid:N" where N is the chunk number
  // We want to use just "uuid" as the entity ID so all chunks accumulate in one entity
  const colonIndex = itemId.lastIndexOf(':');
  if (colonIndex > 0) {
    return itemId.substring(0, colonIndex);
  }
  return itemId;
}

registerSem('artifact.chunk.started', ({ ev, now, convId }) => {
  // debug removed
  const d = (ev.data || {}) as any;
  const rawId = typeof (d.item_id || d.itemId) === 'string' ? d.item_id || d.itemId : ev.id;
  if (!rawId) {
    // debug removed
    return null;
  }

  const stableId = getStableEntityId(rawId);
  const entityId = `editable_summary:${stableId}`;
  // debug removed
  // Use 'add' so we only create the entity once and don't overwrite existing chunks
  return {
    kind: 'add',
    convId,
    entity: {
      id: entityId,
      kind: 'editable_summary',
      timestamp: now,
      props: { status: 'active', content: '', chunks: [] },
    },
  } as any;
});

registerSem('artifact.started', ({ ev, now, convId }) => {
  const d = (ev.data || {}) as any;
  const rawId = typeof (d.item_id || d.itemId) === 'string' ? d.item_id || d.itemId : ev.id;
  if (!rawId) {
    return null;
  }

  const stableId = getStableEntityId(rawId);
  const entityId = `editable_summary:${stableId}`;
  return {
    kind: 'add',
    convId,
    entity: {
      id: entityId,
      kind: 'editable_summary',
      timestamp: now,
      props: { status: 'active', content: '', chunks: [] },
    },
  } as any;
});

registerSem('artifact.chunk.completed', () => {
  // Let the fallback switch in useChatStream handle appending the chunk
  return null;
});
